<template>
  <vxe-pulldown ref="managerDown" destroy-on-close>
    <template #default>
      <div v-if="!uslot" class="flex" style="width: 100%;" @click="togglePanel">
        <div class="bd flex align-items-center">
          <span v-if="rowItem && rowItem.principal_username" class="flex align-items-center">
            <f-user-avatar
              :user="{uid:rowItem.principal,avatar:rowItem.principal_avatar,username:rowItem.principal_username}"
              :preview="false" size="mini" role="button" />
            <!-- <img v-if=" rowItem.principal_avatar" :src="rowItem.principal_avatar" alt="" class="image sm circle" />
						<img v-else src="@/assets/default-avatar.png" alt="" class="image circle sm" /> -->
            <span class="ml-xs ellipsis">{{ rowItem.principal_username }}</span>
          </span>
          <span v-else>暂无负责人</span>
        </div>
        <div class="ft flex-center">
          <i class="el-icon-user" />
        </div>
      </div>

      <div v-else class="flex" style="width: 100%;height:auto;" @click="togglePanel">
        <slot name="default" />
      </div>
    </template>
    <template #dropdown>
      <div class="my-dropdown3 bg-white">
        <el-input v-model="keyword" placeholder="输入成员名称">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-scrollbar style="max-height:360px" :native="false" :noresize="true" tag="ul">
          <div v-for="item in showList" :key="item.uid" class="flex down-item pr pl pt-sm pb-sm  mt-sm"
            @click="handleChange(item)">
            <span class="bd flex align-items-center">
              <f-user-avatar :user="item" :preview="false" size="mini" role="button" />
              <!-- <img v-if="item.avatar" :src="item.avatar" alt="" class="image sm circle" />
							<img v-else src="@/assets/default-avatar.png" alt="" class="image circle sm" /> -->
              <span class="ml-xs ellipsis">{{ item.username }}</span>
            </span>
            <div v-if="rowItem.principal==item.uid" class="ft flex-center">
              <i class="el-icon-check text-primary"></i>
            </div>
          </div>
        </el-scrollbar>

      </div>
    </template>
  </vxe-pulldown>
</template>

<script>
import { mapState } from "vuex"
export default {
  props: {
    uslot: {
      type: Boolean,
      default: false,
    },
    rowItem: {
      type: [Number, String, Object, null]
    },
    draw: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      keyword: ''
    }
  },
  computed: {
    ...mapState({
      showList (state) {
        return state.middleStore.TeamMember.length ? state.middleStore.TeamMember.filter(item => {
          return item.username.match(this.keyword)
        }) : []
      }
    })

  },

  created () {

  },
  mounted () {
    var that = this;
    this.$nextTick(() => {
      if (that.draw)
        that.togglePanel()
    })

  },
  methods: {
    togglePanel () {
      this.$refs.managerDown.togglePanel()
    },
    handleChange (item) {
      this.$emit('change', item)
      this.$refs.managerDown.hidePanel()
    }
  }
}
</script>

<style lang="scss" scoped>
.my-dropdown3 {
  padding: 10px 5px;
  width: 260px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  position: absolute;
  right: 0;
  background-color: #fff;
}

.down-item {
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(153, 153, 153, 0.2);
  }
}
</style>